<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/campaign-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar informaci&oacute;n campaña" : "Nueva campaña"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar de la campaña" : "Completa los datos para registrar una nueva campaña"}}</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <form #CampaingForm="ngForm" (ngSubmit)="$event.preventDefault()">
            <div class="d-grid prospect-form">
                  <div class="mt-5">
                    <label class="login-label" for="nombre_campana">
                    <span class="required-asterisk"
                            *ngIf="!request.nombre_campana || request.nombre_campana.trim()===''">*</span>
                    Nombre de la campaña:
                    </label>
                    <input
                    class="crm-input"
                    type="text"
                    id="nombre_campana"
                    name="nombre_campana"
                    [(ngModel)]="request.nombre_campana"
                    required
                    #nombreCampanaCtrl="ngModel">
                    <div class="error-text" *ngIf="nombreCampanaCtrl.invalid && nombreCampanaCtrl.touched">
                    <small *ngIf="nombreCampanaCtrl.errors?.['required']">
                        El nombre de la campaña es obligatorio
                    </small>
                    </div>
                </div>
                 <div class="mt-5">
            <label class="login-label" for="estado_campana">
              <span class="required-asterisk"
                    *ngIf="!request.estado_id || request.estado_id === ''">*</span>
              Estado de la campaña:
            </label>
            <select
              class="crm-input"
              id="estado_campana"
              name="estado_id"
              [(ngModel)]="request.estado_id"
              required
              #estadoCampanaCtrl="ngModel">
              <option value="" disabled>Selecciona el estado de la campaña</option>
              <option *ngFor="let row of estados" [value]="row.id_estado">
                {{row.nombre}}
              </option>
            </select>
            <div class="error-text" *ngIf="estadoCampanaCtrl.invalid && estadoCampanaCtrl.touched">
              <small *ngIf="estadoCampanaCtrl.errors?.['required']">
                El estado de la campaña es obligatorio
              </small>
            </div>
          </div>
        </div>
            
            <div class="mt-5">
          <label class="login-label">
            <span class="required-asterisk"
                  *ngIf="!request.segmento_id || request.segmento_id === ''">*</span>
            Segmento de la campaña:
          </label>
          <div style="border: solid 1px #D9D9D9;">
            <div class="crm-ng-select">
              <ng-select
                name="segmento_id"
                [(ngModel)]="request.segmento_id"
                bindLabel="nombre_segmento"
                bindValue="segmento_id"
                [items]="segments"
                placeholder="Buscar segmentos..."
                appendTo="body"
                [searchable]="true"
                [clearable]="false"
                required
                #segmentoCtrl="ngModel">
              </ng-select>
            </div>
          </div>
          <div class="error-text" *ngIf="segmentoCtrl.invalid && segmentoCtrl.touched">
            <small *ngIf="segmentoCtrl.errors?.['required']">
              El segmento de la campaña es obligatorio
            </small>
          </div>
        </div>
            <div class="mt-5">
                <h6 class="text-semibold">Programación de envío</h6>
            </div>
            
            <div class="mt-5">
                <h6 class="">Tipo de envío</h6>
            </div>

            <div class="d-flex flex-row gap-20 mt-3">
                <div>
                <label class="radio-label">
                    <input
                        type="radio"
                        value="now"
                        name="tipo-envio"
                        [(ngModel)]="tipoEnvio"
                        (change)="onTipoEnvioChange()"
                    /> Envío inmediato
                    </label>
                </div>

                <div>
                <label class="radio-label">
                    <input
                        type="radio"
                        value="scheduled"
                        name="tipo-envio"
                        [(ngModel)]="tipoEnvio"
                        (change)="onTipoEnvioChange()"
                    /> Envío programado
                    </label>                
                </div>
            </div>

            <div class="d-grid prospect-form mt-3">
                <div>
                    <label for="fecha-envio" class="login-label">Fecha:</label><br>
                    <input
                    type="date"
                    id="fecha-envio"
                    name="fecha-envio"
                    class="crm-input"
                    [(ngModel)]="request.fecha_envio_fecha"
                    [min]="minDate"
                    [disabled]="tipoEnvio !== 'scheduled'"
                    />
                </div>
                <div>
                    <label for="hora-envio" class="login-label">Hora:</label><br>
                    <input
                        type="time"
                        id="hora-envio"
                        name="hora-envio"
                        class="crm-input"
                        [(ngModel)]="request.fecha_envio_hora"
                        [disabled]="tipoEnvio !== 'scheduled'"
                        />
                </div>
            </div>
            <div class="mt-5">
                <h6 class="">Información del correo</h6>
            </div>

            <div class="mail-form">
                <div class="d-grid mail-input mt-3">
                <div>
                <label class="login-label">
                    <span class="required-asterisk"
                        *ngIf="!request.from || request.from.trim()===''">*</span>
                    De:
                </label>
                </div>
                <div>
                <input
                    class="crm-input"
                    type="text"
                    name="from"
                    [(ngModel)]="request.from"
                    required
                    #fromCtrl="ngModel">
                <div class="error-text" *ngIf="fromCtrl.invalid && fromCtrl.touched">
                    <small *ngIf="fromCtrl.errors?.['required']">
                    El campo "De" es obligatorio
                    </small>
                </div>
                </div>
            </div>
                <hr class="mt-2">
                <div class="d-grid mail-input mt-3">
                    <div>
                        <label class="login-label" for="">CC:</label>
                    </div>
                    <div>
                        <input class="crm-input" type="text" name="cc" id="cc" [(ngModel)]="request.cc">
                    </div>
                </div>
                <hr class="mt-2">
                  <div class="d-grid mail-input mt-3">
                    <div>
                    <label class="login-label">
                        <span class="required-asterisk"
                            *ngIf="!request.asunto || request.asunto.trim()===''">*</span>
                        Asunto:
                    </label>
                    </div>
                    <div>
                    <input
                        class="crm-input"
                        type="text"
                        name="asunto"
                        [(ngModel)]="request.asunto"
                        required
                        #asuntoCtrl="ngModel">
                    <div class="error-text" *ngIf="asuntoCtrl.invalid && asuntoCtrl.touched">
                        <small *ngIf="asuntoCtrl.errors?.['required']">
                        El asunto es obligatorio
                        </small>
                    </div>
                    </div>
                </div>
                <hr class="mt-2">
                <div class="d-grid mail-input mt-3">
                    <div>
                    <label class="login-label">
                        <span class="required-asterisk"
                            *ngIf="!request.saludo_inicial || request.saludo_inicial.trim()===''">*</span>
                        Saludo inicial:
                    </label>
                    </div>
                    <div>
                    <input
                        class="crm-input"
                        type="text"
                        name="saludo_inicial"
                        [(ngModel)]="request.saludo_inicial"
                        required
                        #saludoCtrl="ngModel">
                    <div class="error-text" *ngIf="saludoCtrl.invalid && saludoCtrl.touched">
                        <small *ngIf="saludoCtrl.errors?.['required']">
                        El saludo inicial es obligatorio
                        </small>
                    </div>
                    </div>
                </div>
                <hr class="mt-2">
            </div>

            <div class="mt-3" style="display: flex; justify-content: left;">
                <quill-editor 
                name="contenido"
                [(ngModel)]="request.contenido"
                [modules]="quillConfig"
                [styles]="{height: '100px', width: '700px'}"
                placeholder="Escribe tu mensaje aquí..."
                (onContentChanged)="onContentChanged($event)"
                (onEditorCreated)="onEditorCreated($event)">
                </quill-editor>
            </div>

            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button type="button" (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                @if(data.mode === 'edit'){
                    <button type="button" class="btn btn-primary text-center">Modificar campaña</button>
                }@else{
                    <button type="button" class="btn btn-primary text-center" (click)="createCampaign()" [disabled]="!CampaingForm">A&#241;adir campaña</button>
                }
            </div>
            </form>

            <!-- <div class="preview" [innerHTML]="contenido"></div>

            <button (click)="leerData()">Leeme</button> -->
        </div>
    </div>
